import classnames from 'classnames';
import Utils from 'Utils';
import evtBus from 'evtBus';
import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import ReactDOM from 'react-dom';
import { Icon, Button, Typography, message, Spin, Empty } from 'antd';
import { Switch, Route, Link } from 'react-router-dom';
import useFooter from 'useFooter';
import Loading from 'ui-loading';
import Err from 'ui-error';
import AppItem from './ui-ext-item';
import request from 'request';
import Install from 'install';
import getTT from 'getTT';
import imgEmpty from 'assets/img/empty.png';
import styles from './style.scss?__local';

const { Title, Paragraph } = Typography;

function ICenter(route) {
  useFooter()

  const fetch = useMemo(() => request({
    type: 'GET',
    url: request.api.extInstallList,
  }), [])

  let [fetchRes, setFetchRes] = useState(null)

  useEffect(() => {
    let mouted = true

    getTT(TT => {
      if (mouted) {

        // 有时不知道为什么拿不到 TT 的，所以这里做下容错
        if (TT) {
          TT.getUserInfo(userInfo => {
            if (mouted) {
              if (userInfo.uid == 0) {
                TT.login.login()
                TT.login.on('loginClose', () => setFetchRes({ err: '未登录' }))
              } else {
                fetch.done(data => setFetchRes({ data }))
                fetch.fail(err => setFetchRes({ err }))
              }
            }
          })
        } else {
          fetch.done(data => setFetchRes({ data }))
          fetch.fail(err => setFetchRes({ err }))
        }
      }
    })

    return () => {
      mouted = false
      setFetchRes = () => { }
    }
  }, [])

  const elmLoading = fetchRes == null ? <Loading /> : null
  const elmErr = fetchRes && fetchRes.err ? <Err err={`获取数据失败：${fetchRes.err}`} /> : null
  const elmApp = fetchRes && !fetchRes.err ? <App data={fetchRes.data || []} /> : null

  return (
    <div>
      {elmLoading}
      {elmErr}
      {elmApp}
    </div>
  )
}

function App({ data }) {
  yaReportArr.push({
    eid: 'sys/pageview/appstore/iCenter',
    eid_desc: '小程序商店个人中心pv',
  })

  return (
    <div className={styles.app}>
      <div className={styles['my-app']}>
        <div className={styles['my-app-hd']}>
          <div className={styles['my-app-tit']}>
            已安装小程序
          </div>
        </div>
        <div className={styles['my-app-bd']}>
          <div className={styles['my-app-list']}>
            <div className={styles['my-app-list-column']}>
              {
                data.filter((item, idx) => idx % 3 === 0).map(item => (
                  <div className={styles['my-app-item']} key={`${item.extUuid}.${item.extVersionId}`}>
                    <AppItem
                      data={item}
                      install={new Install(item, 0)}
                    />
                  </div>
                ))
              }
            </div>
            <div className={styles['my-app-list-column']}>
              {
                data.filter((item, idx) => idx % 3 === 1).map(item => (
                  <div className={styles['my-app-item']} key={`${item.extUuid}.${item.extVersionId}`}>
                    <AppItem
                      data={item}
                      install={new Install(item, 0)}
                    />
                  </div>
                ))
              }
            </div>
            <div className={styles['my-app-list-column']}>
              {
                data.filter((item, idx) => idx % 3 === 2).map(item => (
                  <div className={styles['my-app-item']} key={`${item.extUuid}.${item.extVersionId}`}>
                    <AppItem
                      data={item}
                      install={new Install(item, 0)}
                    />
                  </div>
                ))
              }
            </div>
          </div>
          {
            !data.length && (
              <Empty
                image={imgEmpty}
                description={<span>尚未拥有~</span>}
              />
            )
          }
        </div>
      </div>
    </div>
  )
}

export default ICenter;